export { default } from './wrapperValue.js'



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/valueOf.js
// module id = 783
// module chunks = 41